import { FC } from 'react'
import shallow from 'zustand/shallow'
import useEmployeesAndTags from '../../graphql/ranking/hooks/useEmployeesAndTags'
import useCompanyRankingSettingsOfCompany from '../../graphql/company-ranking-settings/hooks/useCompanyRankingSettingsOfCompany'
import { LoadingAndErrors } from '../../components/custom_components/LoadingAndErrors'
import { RankingViewContent } from './RankingViewContent'
import { useCultivatingTalentsStore } from './CultivatingTalentsStore'

/* TODO
 *  - Implement global state managment for the child components starting with <RankingViewContent />
 *  - Check for posibility to combine useEmployeesAndTags and useCompanyRankingSettingsOfCompany into one query
 *  - Move data from the above two queries into the store and access it from the child components instead of prop drilling.
 */
export const RankingViewContentWrapper: FC = () => {
  const [selected] = useCultivatingTalentsStore((state) => [state.selected], shallow)

  const { data, error, loading } = useEmployeesAndTags(selected.companyId, selected.country)

  const {
    data: companyRankingSettingsData,
    error: companyRankingSettingsError,
    loading: companyRankingSettingsLoading,
  } = useCompanyRankingSettingsOfCompany(selected.companyId, selected.country)

  const isLoadingOrError =
    loading ||
    error ||
    companyRankingSettingsLoading ||
    companyRankingSettingsError ||
    !data ||
    !data.employeesAndTags ||
    !companyRankingSettingsData ||
    !companyRankingSettingsData.companyRankingSettingsForCountry

  if (isLoadingOrError) {
    return (
      <LoadingAndErrors
        isLoading={loading || companyRankingSettingsLoading}
        hasNoData={!data || !companyRankingSettingsData}
        error={error || companyRankingSettingsError}
        showSpinner
      />
    )
  } else if (!!data && !!companyRankingSettingsData) {
    return (
      <RankingViewContent
        settings={companyRankingSettingsData.companyRankingSettingsForCountry}
        data={data.employeesAndTags}
        companyId={selected.companyId}
        country={selected.country}
      />
    )
  }
  return null
}
